import {
  emailFoot,
  emailHead,
  EmailTemplate,
  EmailTemplateProps,
} from "src/components/email/EmailTemplate";

const sampleData: EmailTemplateProps = {
  logo: "https://api.captyn.com/s3/b74eb101-e2d0-4656-943f-a95d15ed7dda",
  subhead: "",
  content:
    "<p>Dear Frank,</p><p>Your enrollment summary is below.</p><p>To manage your enrollments, sign in anytime.</p><p>Sincerely,<br />Naples Swim School</p>",
  registrations: [
    {
      statusColor: "#FFCB33",
      status: "Active",
      roster: [
        {
          name: "Jelly Belly",
          age: "2 years",
          gender: "Male",
        },
      ],
      program: "Swimming Fundamentals",
      ages: "Ages 4-8",
      classTimes: [
        {
          day: "M",
          date: "",
          startTime: "8 am",
          endTime: "8:30 am",
          instructor: "Jerry Barmore",
          location: "Naples",
          zone: "Area 1",
        },
        {
          day: "T",
          date: "",
          startTime: "7:45 am",
          endTime: "8:45 am",
          instructor: "Frank Jones",
          location: "Swimming Pool",
        },
      ],

      offeringStatus: "In Progress",
      offeringStatusColor: "green",
      finalDate: "Thu, Aug 27, 2019",
      url: "#",
    },
  ],
  organizationUrl: "naples.captyn.com",
  organizationName: "Naples Swim School",
};

export default function EmailTest() {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: emailHead }} />
      <EmailTemplate {...sampleData} />
      <div dangerouslySetInnerHTML={{ __html: emailFoot }} />
    </>
  );
}
